export default {"src":"/_next/static/media/disc-wheels.2ad69635.svg","height":382,"width":556,"blurWidth":0,"blurHeight":0};